/**
 * LiveRegion -- visually hidden container that announces dynamic changes to screen readers.
 */
interface LiveRegionProps {
  /** The announcement text. When this changes, screen readers will read it. */
  message: string;
  /** 'polite' waits for the user to finish, 'assertive' interrupts immediately */
  priority?: 'polite' | 'assertive';
}

export function LiveRegion({ message, priority = 'polite' }: LiveRegionProps) {
  return (
    <div
      role="status"
      aria-live={priority}
      aria-atomic="true"
      className="sr-only"
    >
      {message}
    </div>
  );
}
